import { AlertBlockError } from '@klarna/bubble-ui';
import PropTypes from 'prop-types';
import React from 'react';
export const ErrorComponent = ({ errorText }) => (React.createElement("div", { "data-testid": 'insights_widget_error' },
    React.createElement(AlertBlockError, { content: [errorText] })));
ErrorComponent.propTypes = {
    errorText: PropTypes.string.isRequired
};
